// Location data with country codes, states, and cities
export interface Country {
  code: string;
  name: string;
  states: State[];
}

export interface State {
  code: string;
  name: string;
  cities: City[];
}

export interface City {
  code: string;
  name: string;
}

// German states with their cities and abbreviations
export const LOCATION_DATA: Country[] = [
  {
    code: 'DE',
    name: 'Deutschland',
    states: [
      {
        code: 'BW',
        name: 'Baden-Württemberg',
        cities: [
          { code: 'S', name: 'Stuttgart' },
          { code: 'KA', name: 'Karlsruhe' },
          { code: 'MA', name: 'Mannheim' },
          { code: 'HD', name: 'Heidelberg' },
          { code: 'UL', name: 'Ulm' },
          { code: 'PF', name: 'Pforzheim' },
          { code: 'RV', name: 'Ravensburg' },
          { code: 'KN', name: 'Konstanz' },
          { code: 'FR', name: 'Freiburg im Breisgau' },
          { code: 'HN', name: 'Heilbronn' }
        ]
      },
      {
        code: 'BY',
        name: 'Bayern',
        cities: [
          { code: 'M', name: 'München' },
          { code: 'N', name: 'Nürnberg' },
          { code: 'A', name: 'Augsburg' },
          { code: 'WÜ', name: 'Würzburg' },
          { code: 'R', name: 'Regensburg' },
          { code: 'IN', name: 'Ingolstadt' },
          { code: 'FÜ', name: 'Fürth' },
          { code: 'ER', name: 'Erlangen' },
          { code: 'BA', name: 'Bamberg' },
          { code: 'AS', name: 'Aschaffenburg' }
        ]
      },
      {
        code: 'BE',
        name: 'Berlin',
        cities: [
          { code: 'B', name: 'Berlin' }
        ]
      },
      {
        code: 'BB',
        name: 'Brandenburg',
        cities: [
          { code: 'P', name: 'Potsdam' },
          { code: 'CB', name: 'Cottbus' },
          { code: 'FF', name: 'Frankfurt (Oder)' },
          { code: 'BRB', name: 'Brandenburg an der Havel' }
        ]
      },
      {
        code: 'HB',
        name: 'Bremen',
        cities: [
          { code: 'HB', name: 'Bremen' },
          { code: 'BHV', name: 'Bremerhaven' }
        ]
      },
      {
        code: 'HH',
        name: 'Hamburg',
        cities: [
          { code: 'HH', name: 'Hamburg' }
        ]
      },
      {
        code: 'HE',
        name: 'Hessen',
        cities: [
          { code: 'F', name: 'Frankfurt am Main' },
          { code: 'WI', name: 'Wiesbaden' },
          { code: 'KS', name: 'Kassel' },
          { code: 'DA', name: 'Darmstadt' },
          { code: 'OF', name: 'Offenbach am Main' },
          { code: 'GI', name: 'Gießen' },
          { code: 'MR', name: 'Marburg' },
          { code: 'FD', name: 'Fulda' }
        ]
      },
      {
        code: 'MV',
        name: 'Mecklenburg-Vorpommern',
        cities: [
          { code: 'SN', name: 'Schwerin' },
          { code: 'HRO', name: 'Rostock' },
          { code: 'NB', name: 'Neubrandenburg' },
          { code: 'HST', name: 'Stralsund' }
        ]
      },
      {
        code: 'NI',
        name: 'Niedersachsen',
        cities: [
          { code: 'H', name: 'Hannover' },
          { code: 'BS', name: 'Braunschweig' },
          { code: 'OL', name: 'Oldenburg' },
          { code: 'OS', name: 'Osnabrück' },
          { code: 'WF', name: 'Wolfsburg' },
          { code: 'GÖ', name: 'Göttingen' },
          { code: 'SZ', name: 'Salzgitter' },
          { code: 'HI', name: 'Hildesheim' }
        ]
      },
      {
        code: 'NW',
        name: 'Nordrhein-Westfalen',
        cities: [
          { code: 'K', name: 'Köln' },
          { code: 'D', name: 'Düsseldorf' },
          { code: 'DO', name: 'Dortmund' },
          { code: 'E', name: 'Essen' },
          { code: 'DU', name: 'Duisburg' },
          { code: 'BO', name: 'Bochum' },
          { code: 'W', name: 'Wuppertal' },
          { code: 'BN', name: 'Bonn' },
          { code: 'MS', name: 'Münster' },
          { code: 'MG', name: 'Mönchengladbach' }
        ]
      },
      {
        code: 'RP',
        name: 'Rheinland-Pfalz',
        cities: [
          { code: 'MZ', name: 'Mainz' },
          { code: 'LU', name: 'Ludwigshafen am Rhein' },
          { code: 'KO', name: 'Koblenz' },
          { code: 'TR', name: 'Trier' },
          { code: 'KL', name: 'Kaiserslautern' },
          { code: 'NW', name: 'Neustadt an der Weinstraße' }
        ]
      },
      {
        code: 'SL',
        name: 'Saarland',
        cities: [
          { code: 'SB', name: 'Saarbrücken' },
          { code: 'NK', name: 'Neunkirchen' },
          { code: 'HOM', name: 'Homburg' },
          { code: 'VK', name: 'Völklingen' }
        ]
      },
      {
        code: 'SN',
        name: 'Sachsen',
        cities: [
          { code: 'DD', name: 'Dresden' },
          { code: 'L', name: 'Leipzig' },
          { code: 'C', name: 'Chemnitz' },
          { code: 'Z', name: 'Zwickau' },
          { code: 'PLZ', name: 'Plauen' },
          { code: 'GR', name: 'Görlitz' },
          { code: 'FG', name: 'Freiberg' }
        ]
      },
      {
        code: 'ST',
        name: 'Sachsen-Anhalt',
        cities: [
          { code: 'MD', name: 'Magdeburg' },
          { code: 'HAL', name: 'Halle (Saale)' },
          { code: 'DE', name: 'Dessau-Roßlau' },
          { code: 'WB', name: 'Wittenberg' }
        ]
      },
      {
        code: 'SH',
        name: 'Schleswig-Holstein',
        cities: [
          { code: 'KI', name: 'Kiel' },
          { code: 'HL', name: 'Lübeck' },
          { code: 'FL', name: 'Flensburg' },
          { code: 'NMS', name: 'Neumünster' }
        ]
      },
      {
        code: 'TH',
        name: 'Thüringen',
        cities: [
          { code: 'EF', name: 'Erfurt' },
          { code: 'J', name: 'Jena' },
          { code: 'G', name: 'Gera' },
          { code: 'WE', name: 'Weimar' },
          { code: 'GTH', name: 'Gotha' },
          { code: 'EA', name: 'Eisenach' }
        ]
      }
    ]
  }
];

// Helper functions
export const getCountryByCode = (code: string): Country | undefined => {
  return LOCATION_DATA.find(country => country.code === code);
};

export const getStateByCode = (countryCode: string, stateCode: string): State | undefined => {
  const country = getCountryByCode(countryCode);
  return country?.states.find(state => state.code === stateCode);
};

export const getCityByCode = (countryCode: string, stateCode: string, cityCode: string): City | undefined => {
  const state = getStateByCode(countryCode, stateCode);
  return state?.cities.find(city => city.code === cityCode);
};

export const generateTeamName = (organizationName: string, countryCode: string, stateCode: string, cityCode: string): string => {
  const teamCode = `${countryCode}-${stateCode}-${cityCode}`;
  return organizationName ? `${organizationName} ${teamCode}` : teamCode;
};

export const validateLocation = (countryCode: string, stateCode: string, cityCode: string): boolean => {
  const country = getCountryByCode(countryCode);
  if (!country) return false;

  const state = getStateByCode(countryCode, stateCode);
  if (!state) return false;

  const city = getCityByCode(countryCode, stateCode, cityCode);
  return !!city;
};